import { create } from 'zustand'

export type ErrorState = string | undefined
export type ErrorStore = {
  error: ErrorState
  setError: (error: ErrorState) => void
  reset: () => void
}

export const useError = create<ErrorStore>((set) => ({
  error: undefined,
  setError: (error) => set({ error }),
  reset: () => set({ error: undefined }),
}))
